import { z } from 'zod';
import { formatShortFr, toParisDate } from '../dates.js';
import { IsoDateTime, Uuid } from './common.js';

/**
 * Lot AK : responsable des relances de devis d'un client (`clients.quote_followup_owner_*`). Posé en réattribuant
 * une carte « Relancer le devis » du client à quelqu'un d'autre que la personne des relances (Réglages) ; les
 * relances de devis SUIVANTES du client lui reviennent. Réattribuer à la personne par défaut, ou « Retirer », l'efface.
 */
export const ClientQuoteFollowupOwner = z.object({
  clientId: Uuid,
  clientName: z.string(),
  ownerId: Uuid,
  ownerName: z.string().nullable(),
  /** Quand et par qui (null : membre supprimé). */
  setAt: IsoDateTime,
  setByName: z.string().nullable(),
});
export type ClientQuoteFollowupOwner = z.infer<typeof ClientQuoteFollowupOwner>;

/** `GET /api/clients/quote-followup-owners` : clients qui ont un responsable, du plus récent au plus ancien. */
export const ClientQuoteFollowupOwnerList = z.object({ items: z.array(ClientQuoteFollowupOwner) });
export type ClientQuoteFollowupOwnerList = z.infer<typeof ClientQuoteFollowupOwnerList>;

/** `DELETE /api/clients/:id/quote-followup-owner` : `cleared` faux s'il n'y avait personne. */
export const ClearQuoteFollowupOwnerResult = z.object({
  cleared: z.boolean(),
  /** Lot BR : de quoi annuler (`POST …/quote-followup-owner/restore`) ; null : rien n'a changé. */
  undoId: Uuid.nullable(),
});
export type ClearQuoteFollowupOwnerResult = z.infer<typeof ClearQuoteFollowupOwnerResult>;

/** « Relances de devis suivies par Inès · choisi par Maxime le 12 oct. » */
export function quoteFollowupOwnerText(
  o: Pick<ClientQuoteFollowupOwner, 'ownerName' | 'setAt' | 'setByName'>,
): string {
  const by = o.setByName ? ` par ${o.setByName}` : '';
  return `Relances de devis suivies par ${o.ownerName ?? 'un ancien membre'} · choisi${by} le ${formatShortFr(toParisDate(new Date(o.setAt)))}`;
}
